module.exports = __webpack_public_path__ + "posture/static/img/risk-icon.347b20d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risk-icon.png
// module id = kiVC
// module chunks = 1